//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CartComponent from "../profile/CartComponent";
import HolidaysBanner from "@/components/common/HolidaysBanner";

export default {
  name: "HeaderComponent",
  components: { CartComponent, HolidaysBanner},
  props: {
    bootstrap: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      expandedMenu: null,
      recoverPasswordModal: false,
      password_recovery_token: null,
      loginErrMessage: null,
      confirmMessage: null,
      confirmErrMessage: null,
      forgotPassword: false,
      createAnAccount: false,
      email: null,
      password: null,
      confirmPassword: null,
      top: true,
      login: false,
      open: false,
      wasOpened: false,
      image: '/nav/def.jpg',
      hoverImage: '/nav/castom.jpg',
      desktopMenu: [],
      desktopMenuCode: '',
      hoverMenuTimeout: null
    }
  },
  computed: {
    headerWhiteContent() {
      const routes = ['/', '/more-than-words', '/more-than-words/'];
      return routes.includes(this.$route.path) && !this.open && !this.top;
    },
    defImage() {
      const menuSource = this.desktopMenu?.length ? this.desktopMenu : this.headMenu;
      return menuSource?.length && menuSource[0].icon ? menuSource[0].icon : '/nav/def.jpg';
    },
    headMenu() {
      return this.convertMenu(this.$store.getters.getBootstrap?.data?.menu?.header?.items);
    },
    aboutMenu() {
      return this.convertMenu(this.$store.getters.getBootstrap?.data?.menu?.about?.items);
    },
    userInfo() {
      return this.$store.getters.getUserInfo
    },
    cartModal() {
      return this.$store.getters.getCartModal
    },
    cartId() {
      return this.$store.getters.getCartId
    },
    cart() {
      return this.$store.getters.getCartItems
    },
    cartItemsCount() {
      let c = 0;
      this.$store.getters.getCartItems.forEach(item => {
        c = c + item.quantity
      })
      return c
    }
  },
  methods: {
    convertMenu(storeMenu, columnLinksLimit = 5) {
      let menu = [];
      if (storeMenu && storeMenu.length) {
        menu = storeMenu.filter(item => !item.parent_id);
        menu.map(item => {
          const children = storeMenu.filter(i => i.parent_id === item.id);
          item.items = [];
          let group = [];
          children.forEach((childItem, childindex) => {
            group.push(childItem);
            if (((childindex + 1) % columnLinksLimit) === 0 || children.length === (childindex + 1)) {
              item.items.push(group);
              group = [];
            }
          });
          return item
        })
      }
      return menu;
    },
    setCartHeight() {
      document.querySelector('#cart-modal').style.height = `${window.innerHeight}px`
    },
    hideCart() {
      if (this.cartModal) {
        document.querySelector('#cart-modal').classList.remove('open-cart');
        setTimeout(() => {
          this.$store.commit('setStoreVar', {var: 'cartModal', val: false})
        }, 500)
      }
    },
    openCart() {
      if (!this.cartModal && this.$route.path !== '/cart') {
        document.querySelector('#cart-modal').classList.add('open-cart');
        this.$store.dispatch('getCart');
        setTimeout(() => {
          this.$store.commit('setStoreVar', {var: 'cartModal', val: true})
        }, 500)
      } else {
        document.querySelector('#cart-modal').classList.remove('open-cart');
        setTimeout(() => {
          this.$store.commit('setStoreVar', {var: 'cartModal', val: false})
        }, 500)
      }
    },
    forgotPasswordFunc() {
      this.$refs.form.validate().then(success => {
        if (!success) {
          return false;
        } else {
          const params = {
            email: this.email,
          }
          this.$axios.patch('/users/recover-password', params)
            .then(res => {
              this.email = null;
              if (this.$refs.form) {
                this.$refs.form.reset();
              }
              this.confirmMessage = this.$t('recoverPasswordMessage');
              this.confirmErrMessage = null;
            })
            .catch(err => {
              this.confirmErrMessage = err.response.data.errors[0].message;
            })
        }
      })
    },
    loginFunc() {
      this.$refs.form.validate().then(success => {
        if (!success) {
          return false;
        } else {
          const params = {
            email: (this.email).toLowerCase(),
            password: this.password,
          }
          if (this.cartId) {
            params.cart_unique_id = this.cartId;
          }
          this.$axios.post('/authorizations', params)
            .then(res => {
              this.email = null;
              this.password = null;
              if (this.$refs.form) {
                this.$refs.form.reset();
              }
              this.login = false;
              this.$store.dispatch('setUserInfo', res.data.data);
              this.setKlaviyoUserIdentity(res.data.data);
              this.loginErrMessage = null;
              this.$store.dispatch('getCart');
            })
            .catch(err => {
              this.loginErrMessage = err.response.data.errors[0].message;
            })
        }
      })
    },
    setKlaviyoUserIdentity(user) {
      const _learnq = window._learnq || [];
      _learnq.push(['identify', {
        '$email': user.email,
        "$first_name": user.first_name,
        "$last_name": user.last_name,
        "$phone_number": user.phone,
      }]);
    },
    closeLogin() {
      if (this.$refs.form) {
        this.$refs.form.reset();
      }
      this.login = false;
      this.email = null;
      this.password = null;
      this.confirmPassword = null;
      this.loginErrMessage = null;
    },
    closeCreateAnAccount() {
      if (this.$refs.form) {
        this.$refs.form.reset();
      }
      this.createAnAccount = false;
      this.email = null;
      this.password = null;
      this.confirmPassword = null;
      this.confirmMessage = null;
      this.confirmErrMessage = null;
    },
    closerecoverPasswordModal() {
      if (this.$refs.form) {
        this.$refs.form.reset();
      }
      this.recoverPasswordModal = false;
      this.password_recovery_token = null;
      this.password = null;
      this.confirmPassword = null;
      this.confirmMessage = null;
      this.confirmErrMessage = null;
    },
    createAnAccountFunc() {
      this.$refs.form.validate().then(success => {
        if (!success) {
          return false;
        } else {
          const params = {
            email: this.email,
            password: this.password,
            password_confirmation: this.confirmPassword
          }

          this.$axios.post('/authorizations/sign-up', params)
            .then(res => {
              fbq('track', 'Lead');
              this.email = null;
              this.password = null;
              this.confirmPassword = null;
              this.confirmMessage = this.$t('confirmMessage');
              if (this.$refs.form) {
                this.$refs.form.reset();
              }
              this.confirmErrMessage = null;
            })
            .catch(err => {
              this.confirmErrMessage = err.response.data.errors[0].message;
            })
        }
      })
    },
    recoverPasswordFunc() {
      this.$refs.form.validate().then(success => {
        if (!success) {
          return false;
        } else {
          const params = {
            password_recovery_token: this.password_recovery_token,
            password: this.password,
            password_confirmation: this.confirmPassword
          }

          this.$axios.patch('/users/change-password', params)
            .then(res => {
              this.password = null;
              this.password_recovery_token = null;
              this.confirmPassword = null;
              this.confirmMessage = this.$t('passwordRecoverySuccess');
              if (this.$refs.form) {
                this.$refs.form.reset();
              }
              this.confirmErrMessage = null;
            })
            .catch(err => {
              this.confirmErrMessage = err.response.data.errors[0].message;
            })
        }
      })
    },
    async openMenu(desktopMenuCode, desktopMenu) {
      let preventClose = desktopMenuCode && this.open;
      this.clearHoverMenuTimeout();
      if (desktopMenuCode || !this.open) {
        this.desktopMenuCode = desktopMenuCode && desktopMenu?.length ? desktopMenuCode : 'header';
        this.desktopMenu = this.desktopMenuCode === 'header' ? this.headMenu : desktopMenu;
      }
      this.image = this.defImage;
      if (preventClose) {
        return;
      }
      this.wasOpened = true;
      await this.$nextTick();
      const slideDown = element => element.style.maxHeight = `${element.scrollHeight}px`;
      const slideUp = element => element.style.maxHeight = `0px`;
      this.open = !this.open;
      if (this.open) {
        document.querySelector('.hamburger-menu').classList.add('animate');
        slideDown(document.querySelector(".header__bottom"));
        document.querySelector("body").classList.add("makeFixed");
        document.querySelector("html").classList.add("mobile-oh");
      } else {
        document.querySelector('.hamburger-menu').classList.remove('animate');
        slideUp(document.querySelector(".header__bottom"));
        document.querySelector("body").classList.remove("makeFixed");
        document.querySelector("html").classList.remove("mobile-oh");
      }
      this.expandedMenu = null;
    },
    closeMenu() {
      document.querySelector('.hamburger-menu')?.classList.remove('animate');
      this.open = false;
      const slideUp = element => element?.style ? element.style.maxHeight = `0px` : null;
      slideUp(document.querySelector(".header__bottom"));
      document.querySelector("body").classList.remove("makeFixed");
      document.querySelector("html").classList.remove("mobile-oh");
      this.expandedMenu = null;
      this.clearHoverMenuTimeout();
    },
    closeHoverMenu() {
      this.clearHoverMenuTimeout();
      this.hoverMenuTimeout = setTimeout(() => {
        this.closeMenu();
      }, 500);
    },
    clearHoverMenuTimeout() {
      clearTimeout(this.hoverMenuTimeout);
      this.hoverMenuTimeout = null;
    }
  },
  beforeMount() {
    this.$root.$on('logIn', () => {
      this.login = true
    })
    this.$root.$on('createAnAccount', () => {
      this.createAnAccount = true
    })
  },
  watch: {
    login() {
      if (this.$refs.form) {
        this.$refs.form.reset();
      }
    },
    $route(val) {
      this.closeMenu();
      document.querySelector('#cart-modal').classList.remove('open-cart');
      // $('#cart-modal').animate({"right": "-1000px"}, "500");
      setTimeout(() => {
        this.$store.commit('setStoreVar', {var: 'cartModal', val: false})
      }, 500)
      if (val.query && val.query.rec) {
        this.password_recovery_token = val.query.rec;
        this.recoverPasswordModal = true;
        this.$router.replace({'query': null});
      }
    },
  },
  mounted() {
    this.image = this.defImage;
    this.top = false;
    window.addEventListener('scroll', (e) => {
      this.top = document.documentElement.scrollTop > 0;
    });
  }
}
